export const SET_VALUE_OPTIONS = {
  shouldTouch: true,
  shouldDirty: true,
  shouldValidate: true,
} as const;
